import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';

import { AuthService } from '@auth/auth.service';
import { IErrorResponse } from '@base/interfaces';
import { ExceptionService } from '@base/exceptions.service';

import { trigger, transition, useAnimation } from '@angular/animations';
import { bounceIn } from 'ng-animate';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { FormControlService } from '@base/form-controls.service';

@Component({
  selector: 'app-register',
  templateUrl: './recover.component.html',
  styleUrls: ['./recover.component.sass'],
  animations: [
    trigger('animation', [transition('* => *', useAnimation(bounceIn))])
  ],
})
export class RecoverComponent implements OnInit {
  email = new FormControl(null, [
    Validators.required, Validators.maxLength(100), Validators.email,
  ]);
  showSpinner = false;
  showCard = false;
  recoverForm: FormGroup;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    public snackBar: MatSnackBar,
    private exceptionService: ExceptionService,
    private formControlService: FormControlService,
  ) {
    this.recoverForm = this.fb.group({
      email: this.email,
    });
  }

  ngOnInit() {
    this.showCard = true;
  }

  backLogin = () => {
    this.router.navigate(['']);
  }

  recoverAccount() {
    const info = this.recoverForm.value;
    this.showSpinner = true;
    this.authService.recoverAccount(String(info.email).toLowerCase()).subscribe(
      response => {
        let strMessage: string;
        this.showSpinner = false;

        if (response.success === false) {
          this.openSnackBar(response.message, 'Info');
        } else if (response.success === true) {
          this.recoverForm.reset();
          strMessage = (response.email_sent)
            ? `Se envio un email a ${info.email} para restablecer tu cuenta.`
            : 'No se ha podido enviar el correo de recuperacion, intente luego.';
          this.openSnackBar(strMessage, 'Info');
          setTimeout(() => {
            this.router.navigate(['']);
          }, 2000);
        }
      },
      (err: HttpErrorResponse) => {
        const error: IErrorResponse = this.exceptionService.errorHandling(err);
        this.showSpinner = false;
        // if ((err.status === 400 || err.status === 404) && err.ok === false) {
        //   strMessage = err.error.email[0];
        this.openSnackBar(error.message, error.title);
      }
    );
  }

  openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }

  getErrorMessage(control: FormControl) {
    const strError = this.formControlService.checkErrorInControl(control);
    return strError;
  }
}
